module.exports = __webpack_public_path__ + "static/media/f_hairstyle_frizzy_short_front_shadow.11d55723.png";